import { IContextMenuItem } from '../../interfaces/icontext-menu-item.interface';
import { StructureComponent } from '../../../views/site/structure/structure.component';
import { StructureItemContextMenuItemBase } from './structure-context-menu-base';
import {
    NewFolderContextMenuData, NewFormInstanceContextMenuData, ShowTreeContextMenuData, HideTreeContextMenuData
} from './page-menu-classes';

// Menu Data for the Context Menu opened when right-clicking within the Component that lists Folders/Forms, but not on a Form or Folder itself
export class StructureListViewContextMenuData {
    // Properties.
    private contextMenuData: IContextMenuItem[];

    public get PageContextMenuData(): IContextMenuItem[] {
        return this.contextMenuData;
    }

    // Constructor.
    public constructor(private structureComponent: StructureComponent) {
        this.contextMenuData = [
            new StructureItemContextMenuItemBase('New', this.structureComponent,
                [
                    new NewFolderContextMenuData('Folder ...', this.structureComponent),
                    new NewFormInstanceContextMenuData('Form ...', this.structureComponent)
                ]),
            new StructureItemContextMenuItemBase('Tree', this.structureComponent,
                [
                    new ShowTreeContextMenuData('Show', this.structureComponent),
                    new HideTreeContextMenuData('Hide', this.structureComponent)
                ])
        ];
    }
}
